/**
 * Converted from flindersonline-frontend component
 * GSAP and Swiper are available as global variables
 * Original imports have been removed and replaced with global access
 */

// Promo Switch Tab 1 (For Careers)
(function(){
	"use strict"

	document.addEventListener('DOMContentLoaded', function() {
		const components = document.querySelectorAll('.cmp-flindersonline-promotion-tab-1');

		if(!components.length) return;

		components.forEach(component => {
			const mobile = component.querySelector('.flinders-promotion-mobile');
			setMobileTabs(mobile);
			const desktop = component.querySelector('.flinders-promotion-desktop');
			setDesktopTabs(desktop);
		});
	});

	//SET Tabs for Desktop
	function setDesktopTabs(component){
		const highlight = component.querySelector('.selector-highlight');
		const tabButtons = component.querySelectorAll('.tab-button');
		const tabPanels = component.querySelectorAll('.tab-panel');	
		const tabDescription = component.querySelector('.tab-panel.active .promotion-tab-description');

		function switchTab(index, height, y) {
			// Update highlight position
			highlight.style.transform = `translateY(${y}px)`;
			highlight.style.height = height+'px';
		
			// Update button states
			tabButtons.forEach(btn => btn.classList.remove('active'));
			tabButtons[index].classList.add('active');
		
			// Update panel states
			tabPanels.forEach(panel => panel.classList.remove('active'));
			tabPanels[index].classList.add('active');
		
			// Reset and trigger animations
			const activePanel = tabPanels[index];
			const image = activePanel.querySelector('.promotion-tab-image');
			const content = activePanel.querySelector('.content-wrapper');
		
			image.style.animation = 'none';
			content.style.animation = 'none';
			void image.offsetWidth;
			void content.offsetWidth;
			image.style.animation = '';
			content.style.animation = '';
		}

		// Click handlers for tabs
		tabButtons.forEach(button => {
			button.addEventListener('click', function() {
				const tabIndex = parseInt(this.getAttribute('data-tab'));
				const buttonHeight = this.offsetHeight;
				const buttonY = this.offsetTop;
				switchTab(tabIndex, buttonHeight, buttonY);
			});
		});

		// Initialize first tab
		switchTab(0, tabButtons[0].offsetHeight, tabButtons[0].offsetTop);

		// Create an intersection observer to detect when hero enters viewport
		const observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {		
					tabDescription.setAttribute("data-slide-up", "true");
					tabDescription.setAttribute("data-slide-delay", "1.5");
					tabDescription.setAttribute("data-slide-duration", "1.5");				
				}
			});
		}, {
			threshold: 0.1
		});

		observer.observe(component);	
	}

	//SET Tabs for Mobile
	function setMobileTabs(component){
		const highlight = component.querySelector('.flinders-promotion-mobile .selector-highlight');
		const tabButtons = component.querySelectorAll('.flinders-promotion-mobile .tab-button');
		const tabPanels = component.querySelectorAll('.flinders-promotion-mobile .tab-panel');
		const tabSelector = component.querySelector('.flinders-promotion-mobile .tab-selector');
		const wrapper = component.querySelector('.flinders-promotion-mobile .tab-selector-wrapper');
	
		// Initialize first tab
		let currentTab = 0;
		updateTab();
	
		// Click handlers for tabs
		tabButtons.forEach(button => {
			button.addEventListener('click', function(e) {
				e.stopPropagation();
				currentTab = parseInt(this.getAttribute('data-tab'));
				updateTab();
				centerTabButton(this);
			});
		});
	
		// Update tab display
		function updateTab() {
			const activeButton = tabButtons[currentTab];
			
			highlight.style.width = `${activeButton.offsetWidth}px`;
			highlight.style.left = `${activeButton.offsetLeft}px`;
			tabButtons.forEach(btn => btn.classList.remove('active'));
			activeButton.classList.add('active');
			
			tabPanels.forEach(panel => panel.classList.remove('active'));
			tabPanels[currentTab].classList.add('active');
			
			// Reset animations
			const activePanel = tabPanels[currentTab];
			const image = activePanel.querySelector('.promotion-tab-image');
			const content = activePanel.querySelector('.content-wrapper');
			
			image.style.animation = 'none';
			content.style.animation = 'none';
			void image.offsetWidth;
			void content.offsetWidth;
			image.style.animation = '';
			content.style.animation = '';
		}
	
			// Center the active tab button
		function centerTabButton(button) {
			const buttonLeft = button.offsetLeft;
			const buttonWidth = button.offsetWidth;
			const wrapperWidth = wrapper.offsetWidth;
		
			wrapper.scrollTo({
				left: buttonLeft - (wrapperWidth / 2) + (buttonWidth / 2),
				behavior: 'smooth'
			});
		}
	
		// Enhanced touch handling
		let isDragging = false;
		let startX = 0;
		let scrollLeft = 0;
	
		const handleDragStart = (e) => {
			isDragging = true;
			startX = (e.pageX || e.touches[0].pageX) - wrapper.offsetLeft;
			scrollLeft = wrapper.scrollLeft;
			wrapper.style.cursor = 'grabbing';
			wrapper.style.userSelect = 'none';
		};
	
		const handleDragEnd = () => {
			isDragging = false;
			wrapper.style.cursor = 'grab';
			wrapper.style.removeProperty('user-select');
		};
	
		const handleDragMove = (e) => {
			if (!isDragging) return;
			e.preventDefault();
			const x = (e.pageX || e.touches[0].pageX) - wrapper.offsetLeft;
			const walk = (x - startX) * 2;
			wrapper.scrollLeft = scrollLeft - walk;
		};
	
		// Mouse events
		wrapper.addEventListener('mousedown', handleDragStart);
		document.addEventListener('mouseup', handleDragEnd);
		document.addEventListener('mousemove', handleDragMove);
	
		// Touch events
		wrapper.addEventListener('touchstart', handleDragStart, { passive: false });
		document.addEventListener('touchend', handleDragEnd);
		document.addEventListener('touchmove', handleDragMove, { passive: false });
	
		// Window resize handler
		window.addEventListener('resize', () => {
			updateTab();
			centerTabButton(tabButtons[currentTab]);
		});
	}
})();